import axios from "axios";
const key = process.env.REACT_APP_API_KEY;

export const storeSearchData = (data) => {
  return {
    type: "quickSearch/storeData",
    payload: data,
  };
};

export const setKeyword = (keyword) => {
  return async (dispatch, getState) => {
    dispatch(storeSearchData({ ...getState().quickSearch, keyword: keyword }));
  };
};

export const getSearchData = (req) => {
  return async (dispatch, getState) => {
    let response = await axios.post(
      `/api/quick_search?code=${key}&&type=getOffer`,
      {}
    );
    dispatch(storeSearchData({ ...getState().quickSearch, ...response.data }));
  };
};
